var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"navbar-container bg-light"},[_c('HeroSection'),_c('KategoriSection'),_c('PoSection'),_c('ProductSection'),_c('FooterSection')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }